import { Box } from "@mui/material";
import SatelliteDataReportSummaryPage from "./SatelliteDataReportSummaryPage";
import SatelliteDataSoilMoisturePage from "./SatelliteDataSoilMoisturePage";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SatelliteDataReport = () => {
  const { encryptedId, language, accessKey } = useParams();
  const [farmId, setFarmId] = useState(null);
  const [date, setDate] = useState(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!encryptedId) return;
    const dateString = encryptedId.substring(0, 8);
    const date = `${dateString.substring(0, 4)}-${dateString.substring(
      4,
      6
    )}-${dateString.substring(6, 8)}`;
    const farmId = encryptedId.substring(8);

    setFarmId(farmId);
    setDate(date);
  }, [encryptedId]);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  if (!farmId || !date || !accessKey) return null;

  return (
    <Box sx={{ marginBottom: "-3rem" }}>
      <Box sx={{ minHeight: "1110px" }}>
        <SatelliteDataReportSummaryPage
          farmId={farmId}
          date={date}
          language={language}
        />
      </Box>
      <Box mt={1}>
        <SatelliteDataSoilMoisturePage accessKey={accessKey} />
      </Box>
    </Box>
  );
};

export default SatelliteDataReport;
